<template>
    <v-container fluid style="background-color: white; height: inherit;">

        <CenteredLoading v-if="isLoading && !initiated" :displayBool="true">
        </CenteredLoading>

        <v-form v-else v-model="valid" :key="iteration">
            <v-col>
                <v-row no-gutters v-for="setting in settingList" :key="setting.Name">
                    <ERPIntegrationSettingRow :setting="setting">
                    </ERPIntegrationSettingRow>
                </v-row>
                <v-row no-gutters class="mt-3">
                    <v-btn :disabled="!saveable" :loading="isLoading" :color="saveable ? 'primary' : 'disabled'"
                        @click="saveSettings()">
                        {{ $t('servicesystem.common_objects.commonterms.save') }}
                    </v-btn>
                </v-row>
            </v-col>
        </v-form>
    </v-container>

</template>


<script>
import clientAPI from "@/api/ClientAPIMixin";
import QInputRuleMixin from "@/helpers/Mixins/QInputRuleMixin";
import CenteredLoading from "@/components/Sections/CenteredLoading.vue";
import ERPIntegrationSettingRow from "./ERPIntegrationSettingRow.vue";

export default {
    name: "ERPIntegrationSettings",
    components: {
        CenteredLoading,
        ERPIntegrationSettingRow,
    },
    mixins: [clientAPI, QInputRuleMixin],

    data() {
        return {
            initiated: false,
            isLoading: false,
            settingList: [],
            iteration: 1,
            valid: false,
        };
    },

    mounted() {
        this.fetchSettings();
    },

    methods: {
        fetchSettings() {
            this.isLoading = true;
            clientAPI.methods.getERPIntegrationSettings()
                .then(response => {
                    this.settingList = response.Settings;
                    this.iteration++;
                })
                .finally(() => {
                    this.isLoading = false;
                    this.initiated = true;
                });
        },

        async saveSettings() {
            this.isLoading = true;
            const payload = {
                Settings: Object.assign([], this.settingList),
            };

            await clientAPI.methods.saveERPIntegrationSettings(payload)
                .then(response => {
                    this.settingList = response.Settings;
                    this.iteration++;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },

    computed: {
        saveable() {
            return this.initiated && this.valid && !this.isLoading;
        }
    },

    watch: {},
};
</script>


<style lang="scss" scoped></style>